import {Component, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';

export interface MultiSelectOption {
    label: string;
    value: any;
}

export interface MultiSelectField {
    name: string;
    possibleValues?: [any, string][];
}

@Component({
    selector: 'wm-multiselect-with-custom-input',
    templateUrl: './multiselect-with-custom-input.component.html',
    styleUrls: ['./multiselect-with-custom-input.component.less']
})
export class MultiSelectWithCustomInputComponent {
    @Input() fieldId!: string;
    @Input() field!: MultiSelectField;
    @Input() control!: AbstractControl;

    customInput = '';

    get options(): MultiSelectOption[] {
        const baseOptions = (this.field.possibleValues || [])
            .map(([value, label]) => ({label, value}));

        // Include any selected values that aren't in possibleValues
        const selected = this.control?.value;
        if (Array.isArray(selected)) {
            selected.forEach(val => {
                if (!baseOptions.some(opt => opt.value === val)) {
                    baseOptions.push({label: val, value: val});
                }
            });
        }

        return baseOptions;
    }

    addCustomValue(): void {
        const value = this.customInput?.trim();
        if (!value) {
            return;
        }

        // Add to possibleValues if not already present
        if (!this.field.possibleValues) {
            this.field.possibleValues = [];
        }

        if (!this.field.possibleValues.some(([val]) => val === value)) {
            this.field.possibleValues = [[value, value], ...this.field.possibleValues];
        }

        // Add to form control value
        const current = Array.isArray(this.control.value) ? this.control.value : [];
        if (!current.includes(value)) {
            this.control.setValue([...current, value]);
        }

        this.customInput = '';
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.addCustomValue();
            event.preventDefault();
        }
    }

    onInputChange(value: string): void {
        this.customInput = value;
    }
}
